import { render, staticRenderFns } from "./EmbeddedPersonDetail.vue?vue&type=template&id=a547bde0"
import script from "./EmbeddedPersonDetail.vue?vue&type=script&lang=js"
export * from "./EmbeddedPersonDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports